export default __webpack_public_path__ + "locales/en/MainBar.json?hash=dff11794f20293795eab916fee31be25";